import stateNames from "$data/state_names.json";

const idMap = new Map(stateNames.map((d) => [d.geoid, d]).concat([["00", {state_name: "National", state_abbr: "US", geoid: "00"}]]));

/**
 * Get the abbreviation of a US state by its GEOID.
 * @param {string} geoid - The GEOID of the state.
 * @returns {string|null} - The abbreviation of the state, or null if not found.
 */
export function getAbb(geoid) {
  const entry = idMap.get(geoid);
  return entry ? entry.state_abbr : null;
}

/**
 * Get the full name of a US state by its GEOID.
 * @param {string} geoid - The GEOID of the state.
 * @returns {string|null} - The full name of the state, or null if not found.
 */
export function getName(geoid) {
  const entry = idMap.get(geoid);
  return entry ? entry.state_name : null;
}

/**
 * Get the formatted name of a congressional district by its GEOID.
 * @param {string} geoid - The GEOID of the congressional district (e.g., "0101" for Alabama's 1st district).
 * @returns {string} - The formatted name of the congressional district (e.g., "AL-01" or "Alabama District 1").
 */
export function getCdAbb(geoid) {
  const stateGeoid = geoid.slice(0, 2);
  const stateAbb = getAbb(stateGeoid);
  const cdNumber = geoid.slice(2);
  return `${stateAbb}-${cdNumber}`;
}

/**
 * Get the formatted name of a congressional district by its GEOID.
 * @param {string} geoid - The GEOID of the congressional district (e.g., "0101" for Alabama's 1st district).
 * @returns {string} - The formatted name of the congressional district (e.g., "AL-01" or "Alabama District 1").
 */
export function getCdName(geoid) {
  const stateGeoid = geoid.slice(0, 2);
  const stateName = getName(stateGeoid);
  const cdNumber = geoid.slice(2);
  return `${stateName} District ${cdNumber}`;
}

export function getAllStates() {
  return Array.from(idMap.values())
}
